export const MARKETPLACE_TOKEN_KEY = 'microsoft_marketplace_token';
export const MARKETPLACE_FLOW_KEY = 'microsoft_marketplace_flow_active';
export const MARKETPLACE_LOGIN_PENDING_KEY = 'microsoft_marketplace_login_pending';

export function startMarketplaceFlow(token: string): void {
    if (!token.trim()) {
        return;
    }
    sessionStorage.setItem(MARKETPLACE_TOKEN_KEY, token);
    sessionStorage.setItem(MARKETPLACE_FLOW_KEY, '1');
}

export function clearMarketplaceFlow(): void {
    sessionStorage.removeItem(MARKETPLACE_TOKEN_KEY);
    sessionStorage.removeItem(MARKETPLACE_FLOW_KEY);
    sessionStorage.removeItem(MARKETPLACE_LOGIN_PENDING_KEY);
}

export function getMarketplaceToken(): string | null {
    return sessionStorage.getItem(MARKETPLACE_TOKEN_KEY);
}

export function shouldResumeMarketplaceFlow(): boolean {
    return (
        sessionStorage.getItem(MARKETPLACE_FLOW_KEY) === '1'
        && Boolean(getMarketplaceToken())
    );
}

export function setMarketplaceLoginPending(): void {
    sessionStorage.setItem(MARKETPLACE_LOGIN_PENDING_KEY, '1');
}

export function isMarketplaceLoginPending(): boolean {
    return sessionStorage.getItem(MARKETPLACE_LOGIN_PENDING_KEY) === '1';
}

export function clearMarketplaceLoginPending(): void {
    sessionStorage.removeItem(MARKETPLACE_LOGIN_PENDING_KEY);
}
